import { CanvasView } from "../features/canvas/canvas-view";

interface Props {
  readonly canvasId: string;
}

export function CanvasPage({ canvasId }: Props): JSX.Element {
  return <CanvasView canvasId={canvasId} />;
}
